{
    "version": 8,
    "name": "NLS Basemap",
    "center": [
        21.645,
        63.101
    ],
    "zoom": 11.35,
    "sources": {
        "point": {
            "type": "geojson",
            "data": {
                "type": "FeatureCollection",
                "features": []
            }
        },
        "taustakartta": {
            "type": "vector",
    "tiles" : [ "https://avoin-visukuva.nls.fi/wmts-vt-service/vectortiles/wmts/1.0.0/taustakartta/default/v21/WGS84_Pseudo-Mercator/{z}/{y}/{x}.pbf" ]
 
        },
        "rasteritaustakartta": {
          "type": "raster",
          "tileSize": 256,
          "tiles": [
            "https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/ortokuva/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2"
          ]
        }
    },
    "glyphs": "https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/glyphs/{fontstack}/{range}.pbf?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2",
    "layers": [
        {
            "id": "background",
            "type": "background",
            "paint": {
                "background-color": "white"
            }
        },
            
        {
            "id": "maasto_alue",
            "type": "fill",
            "source": "taustakartta",
            "source-layer": "maasto_alue",
            "filter": [
                "match",
                [
                    "get",
                    "kohdeluokka"
                ],
                [
                    35300,
                    35411,
                    35412,
                    35421,
                    35422,
                    34300,
                    34100,
                    34700,
                    38300,
                    38700,
                    39110,
                    39120,
                    39130,
                    33000,
                    38400,
                    38600,
                    35401,
                    35402
                ],
                true,
                false
            ],
            "paint": {
                "fill-color": [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        35400,
                        35411,
                        35421,
                        35401
                    ],
                    "#CaEfEa",
                    [
                        35412,
                        35422,
                        35402
                    ],
                    "#d9ead4",
                    [
                        35300
                    ],
                    "#CaEfEa",
                    [
                        34100,
                        38600
                    ],
                    "hsla(208, 11%, 75%, 0.5)",
                    [
                        34700
                    ],
                    "hsl(208, 27%, 85%)",
                    [
                        38300,
                        38700,
                        38400,
                        39130
                    ],
                    "hsl(207, 100%, 94%)",
                    [
                        39110
                    ],
                    "hsla(44, 100%, 83%, 0.84)",
                    [
                        39120
                    ],
                    "hsl(65, 57%, 91%)",
                    "hsla(360, 100%, 100%, 0)"
                ]
            }
        },
        {
            "id": "maankaytto",
            "type": "fill",
            "source": "taustakartta",
            "source-layer": "maankaytto",
            "filter": [
                "match",
                [
                    "get",
                    "kohdeluokka"
                ],
                [
                    32111,
                    32112,
                    32113,
                    32200,
                    32300,
                    32500,
                    32611,
                    32612,
                    32800,
                    32900,
                    33100,
                    34300,
                    38900,
                    40200
                ],
                true,
                false
            ],
            "paint": {
                "fill-color": [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    40200,
                    "#f8fbf5",
                    32611,
                    "#f9f4d2",
                    32200,
                    "hsl(87, 45%, 72%)",
                    32612,
                    "hsl(87, 45%, 72%)",
                    32800,
                    "hsl(87, 45%, 72%)",
                    32900,
                    "hsl(87, 45%, 72%)",
                    33100,
                    "hsl(87, 65%, 82%)",
                    34300,
                    "hsl(60, 55%, 80%)",
                    32500,
                    "#dde5dd",
                    "#f7f7f3"
                ]
            }
        },
        {
            "id": "maankaytto_reuna",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "maankaytto",
            "filter": [
                "match",
                [
                    "get",
                    "kohdeluokka"
                ],
                [
                    33100
                ],
                true,
                false
            ],
            "paint": {
                "line-color": [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        33100
                    ],
                    "hsl(87, 15%, 52%)",
                    "hsl(87, 65%, 82%)"
                ]
            }
        },
        {
            "id": "lentokentta_alue",
            "type": "fill",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "Polygon"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        32411,
                        32412,
                        32413,
                        32414,
                        32415,
                        32416,
                        32417,
                        32418,
                        32441,
                        32442
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "fill-color": [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        32411,
                        23412
                    ],
                    "#d0d0d0",
                    [
                        32413,
                        32415,
                        32416,
                        32441,
                        32442
                    ],
                    "#f0f0f0",
                    [
                        32414,
                        32417,
                        32418
                    ],
                    "#e0e0e0",
                    "hsl(0,0%,80%)"
                ],
                "fill-outline-color": [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        32441,
                        32442
                    ],
                    "#c8c4c5",
                    "hsla(360, 100%, 100%, 0)"
                ]
            }
        },
        {
            "id": "lentokentta_viiva",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    32431
                ],
                [
                    "==",
                    "kohdeluokka",
                    32432
                ]
            ],
            "paint": {
                "line-width": 7,
                "line-color": "#e0e0e0"
            }
        },
        {
            "id": "lentokentta_viiva2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    32431
                ],
                [
                    "==",
                    "kohdeluokka",
                    32432
                ]
            ],
            "paint": {
                "line-width": 12,
                "line-color": "#e0e0e0"
            }
        },
        {
            "id": "korkeus_viiva",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "korkeus",
            "minzoom": 0,
            "maxzoom": 20,
            "paint": {
                "line-color": "rgba(252, 179, 110, 1)",
                "line-width": 1
            }
        },
        {
            "id": "korkeus_paaviiva",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "korkeus",
            "minzoom": 0,
            "filter": [
                "all",
                [
                    "has",
                    "korkeusarvo"
                ],
                [
                    "==",
                    [
                        "%",
                        [
                            "get",
                            "korkeusarvo"
                        ],
                        20000
                    ],
                    0
                ]
            ],
            "paint": {
                "line-color": "rgba(252, 179, 110, 1)",
                "line-width": 2.5
            }
        },
        {
            "id": "korkeus_paaviiva2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "korkeus",
            "minzoom": 0,
            "maxzoom": 20,
            "filter": [
                "all",
                [
                    "has",
                    "korkeus"
                ],
                [
                    "==",
                    [
                        "%",
                        [
                            "get",
                            "korkeus"
                        ],
                        20
                    ],
                    0
                ]
            ],
            "paint": {
                "line-color": "rgba(252, 179, 110, 1)",
                "line-width": 2
            }
        },
        {
            "id": "vesisto_alue_reuna",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "vesisto_alue",
            "paint": {
                "line-color": "hsl(200, 80%, 75%)",
                "line-width": 2.5
            }
        },
        {
            "id": "vesisto_alue",
            "type": "fill",
            "source": "taustakartta",
            "source-layer": "vesisto_alue",
            "paint": {
                "fill-color": "hsl(200, 80%, 85%)"
            }
        },
        {
            "id": "vesisto_viiva",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "vesisto_viiva",
            "filter": [
                "in",
                "kohdeluokka",
                36312,
                36314,
                36316
            ],
            "paint": {
                "line-color": "#90C8FF",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    30
                ]
            }
        },
        {
            "id": "vesisto_viiva_kapea",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "vesisto_viiva",
            "filter": [
                "==",
                "kohdeluokka",
                36311
            ],
            "paint": {
                "line-color": "#A0C8FF",
                "line-width": 2
            }
        },
        {
            "id": "maastoaluereuna",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "maastoaluereuna",
            "filter": [
                "all",
                [
                    "in",
                    "kartografinenluokka",
                    32200,
                    32300,
                    32411,
                    32412,
                    32413,
                    32414,
                    32415,
                    32416,
                    32417,
                    32418,
                    33100
                ],
                [
                    "==",
                    "kohdeluokka",
                    30211
                ]
            ],
            "paint": {
                "line-color": "#c8c4c5",
                "line-width": 0.5
            }
        },
        {
            "id": "tiet tunnelissa",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12141,
                        12132,
                        12131,
                        12122,
                        12121,
                        12112,
                        12111,
                        12313,
                        12314,
                        12136
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -11
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    32,
                    16
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "ajotie, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12141
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "ajopolku, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12316
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#595",
                "line-dasharray": [
                    12,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "polku, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12313
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    2,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystamaton, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-dasharray": [
                    3,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystetty, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "tiet_1a_1b_reuna, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    6,
                    20,
                    84
                ]
            }
        },
        {
            "id": "tiet_2a_2b_reuna, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    63
                ]
            }
        },
        {
            "id": "tiet_3a_3b_reuna, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    3,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_reuna, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    4
                ]
            }
        },
        {
            "id": "tiet_1a_1b_taytto, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    80
                ]
            }
        },
        {
            "id": "tiet_2a_2b_taytto, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    2.5,
                    20,
                    60
                ]
            }
        },
        {
            "id": "tiet_3a_3b_taytto, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.5,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_taytto, pinnan alla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        -1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a1d99b",
                "line-dasharray": [
                    2,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    4
                ]
            }
        },
        {
            "id": "ajotie, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12141
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#808080",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.5,
                    20,
                    20
                ]
            }
        },
        {
            "id": "ajopolku, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12316
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#595",
                "line-dasharray": [
                    12,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "polku, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12313
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#b0b0b0",
                "line-dasharray": [
                    4.5,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    20
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystamaton, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#508050",
                "line-dasharray": [
                    4.5,
                    0.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.2,
                    20,
                    15
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystetty, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#205020",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "tiet_1a_1b_reuna, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    6,
                    20,
                    84
                ]
            }
        },
        {
            "id": "tiet_2a_2b_reuna, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    63
                ]
            }
        },
        {
            "id": "tiet_3a_3b_reuna, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    3,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_reuna, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    14,
                    3
                ]
            }
        },
        {
            "id": "tiet_1a_1b_taytto, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    3,
                    4,
                    20,
                    80
                ]
            }
        },
        {
            "id": "tiet_2a_2b_taytto, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    2.5,
                    20,
                    60
                ]
            }
        },
        {
            "id": "tiet_3a_3b_taytto, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.5,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_taytto, pinnalla",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        0
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a1d99b",
                "line-dasharray": [
                    2,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "ajotie, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12141
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "ajopolku, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12316
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    12,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "polku, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12313
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    2,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystamaton, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-dasharray": [
                    3,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystetty, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#205020",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "tiet_1a_1b_reuna, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    6,
                    20,
                    84
                ]
            }
        },
        {
            "id": "tiet_2a_2b_reuna, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    63
                ]
            }
        },
        {
            "id": "tiet_3a_3b_reuna, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    3,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_reuna, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "tiet_1a_1b_taytto, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    80
                ]
            }
        },
        {
            "id": "tiet_2a_2b_taytto, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    2.5,
                    20,
                    60
                ]
            }
        },
        {
            "id": "tiet_3a_3b_taytto, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.5,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_taytto, sillalla 1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a1d99b",
                "line-dasharray": [
                    2,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "ajotie, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12141
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "ajopolku, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12316
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    12,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "polku, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12313
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    2,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystamaton, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-dasharray": [
                    3,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystetty, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "tiet_1a_1b_reuna, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    6,
                    20,
                    84
                ]
            }
        },
        {
            "id": "tiet_2a_2b_reuna, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    63
                ]
            }
        },
        {
            "id": "tiet_3a_3b_reuna, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    3,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_reuna, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "tiet_1a_1b_taytto, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    80
                ]
            }
        },
        {
            "id": "tiet_2a_2b_taytto, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    2.5,
                    20,
                    60
                ]
            }
        },
        {
            "id": "tiet_3a_3b_taytto, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.5,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_taytto, sillalla 2",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-dasharray": [
                    2,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "ajotie, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12141
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "ajopolku, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12316
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    12,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "polku, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12313
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    2,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystamaton, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-dasharray": [
                    3,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystetty, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "tiet_1a_1b_reuna, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    6,
                    20,
                    84
                ]
            }
        },
        {
            "id": "tiet_2a_2b_reuna, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    63
                ]
            }
        },
        {
            "id": "tiet_3a_3b_reuna, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    3,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_reuna, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "tiet_1a_1b_taytto, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    80
                ]
            }
        },
        {
            "id": "tiet_2a_2b_taytto, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    2.5,
                    20,
                    60
                ]
            }
        },
        {
            "id": "tiet_3a_3b_taytto, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.5,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_taytto, sillalla 3",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        3
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-dasharray": [
                    2,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "ajotie, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12141
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "ajopolku, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12316
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    12,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "polku, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12313
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    2,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystamaton, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-dasharray": [
                    3,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystetty, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "tiet_1a_1b_reuna, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    6,
                    20,
                    84
                ]
            }
        },
        {
            "id": "tiet_2a_2b_reuna, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    63
                ]
            }
        },
        {
            "id": "tiet_3a_3b_reuna, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    3,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_reuna, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "tiet_1a_1b_taytto, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    80
                ]
            }
        },
        {
            "id": "tiet_2a_2b_taytto, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    2.5,
                    20,
                    60
                ]
            }
        },
        {
            "id": "tiet_3a_3b_taytto, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.5,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_taytto, sillalla 4",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        4
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a1d99b",
                "line-dasharray": [
                    2,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "ajotie, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12141
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "ajopolku, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12316
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    12,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "polku, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12313
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    2,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1,
                    20,
                    20
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystamaton, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        1
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-dasharray": [
                    3,
                    1.5
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "kavely- ja pyoratie, paallystetty, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12314
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "paallyste"
                    ],
                    [
                        2
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#90ca6f",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.5,
                    20,
                    15
                ]
            }
        },
        {
            "id": "tiet_1a_1b_reuna, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    6,
                    20,
                    84
                ]
            }
        },
        {
            "id": "tiet_2a_2b_reuna, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    63
                ]
            }
        },
        {
            "id": "tiet_3a_3b_reuna, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#000",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    3,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_reuna, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "tiet_1a_1b_taytto, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12111,
                        12112
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    4,
                    20,
                    80
                ]
            }
        },
        {
            "id": "tiet_2a_2b_taytto, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12121,
                        12122
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    2.5,
                    20,
                    60
                ]
            }
        },
        {
            "id": "tiet_3a_3b_taytto, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12131,
                        12132
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.5,
                    20,
                    30
                ]
            }
        },
        {
            "id": "rautatie_taytto, sillalla 5",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        14111,
                        14110,
                        14112,
                        14131,
                        14121
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "tasosijainti"
                    ],
                    [
                        5
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-dasharray": [
                    2,
                    2
                ],
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    2,
                    10,
                    3
                ]
            }
        },
        {
            "id": "lautta ja lossi",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        12151,
                        12152
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#ccc",
                "line-dasharray": [
                    6,
                    8
                ],
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    1.5,
                    20,
                    30
                ]
            }
        },
        {
            "id": "laiva ja venevaylat",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        16511,
                        16512,
                        16521,
                        16522
                    ],
                    true,
                    false
                ]
            ],
            "layout": {},
            "paint": {
                "line-color": "#a0a0a0",
                "line-dasharray": [
                    6,
                    1,
                    6
                ],
                "line-width": 1
            }
        },
        {
            "id": "hallintorajat",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "hallintoalue",
            "paint": {
                "line-color": "#6000ff",
                "line-width": 2,
                "line-dasharray": [
                    8.5,
                    1.5,
                    1.5,
                    1.5
                ]
            }
        },
        {
            "id": "rakennus",
            "type": "fill",
            "source": "taustakartta",
            "source-layer": "rakennus",
            "paint": {
                "fill-color": [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        42110,
                        42111,
                        42112,
                        42210,
                        42211,
                        42213
                    ],
                    "#f57654",
                    [
                        42120,
                        42121,
                        42122,
                        42220,
                        42221,
                        42222
                    ],
                    "#d0d0c8",
                    [
                        42130,
                        42131,
                        42132,
                        42230,
                        42231,
                        42232
                    ],
                    "#fFaf9c",
                    [
                        42140,
                        42141,
                        42142,
                        42240,
                        42241,
                        42242
                    ],
                    "#d0d0a0",
                    "#d0d0d0"
                ]
            }
        },
        {
            "id": "rakennus_reuna",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "rakennus",
            "paint": {
                "line-color": "#505050"
            }
        },
        {
            "id": "rakennelmat",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "all",
                [
                    "!",
                    [
                        "match",
                        [
                            "get",
                            "tasosijainti"
                        ],
                        [
                            -1
                        ],
                        true,
                        false
                    ]
                ],
                [
                    "!",
                    [
                        "match",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        [
                            45111,
                            45112,
                            44500,
                            44591,
                            22311,
                            22312,
                            26111,
                            45700,
                            44211,
                            44213,
                            22200
                        ],
                        true,
                        false
                    ]
                ]
            ],
            "paint": {
                "line-color": "red",
                "line-width": 5
            }
        },
        {
            "id": "rakennelmat_laituri",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    45111
                ],
                [
                    "==",
                    "kohdeluokka",
                    45112
                ]
            ],
            "paint": {
                "line-color": "#918a8c",
                "line-width": 3
            }
        },
        {
            "id": "rakennelmat_muurityms",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    45700
                ]
            ],
            "paint": {
                "line-color": "#554634",
                "line-width": 1
            }
        },
        {
            "id": "rakennelmat_muurityms1",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    45700
                ]
            ],
            "paint": {
                "line-color": "#554634",
                "line-width": 1,
                "line-offset": 2
            }
        },
        {
            "id": "rakennelmat_aita_tekoaines",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    44211
                ]
            ],
            "paint": {
                "line-color": "#54587f",
                "line-width": 2,
                "line-dasharray": [
                    20,
                    1,
                    0.5,
                    1
                ]
            }
        },
        {
            "id": "rakennelmat_aita_istutettu",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    44213
                ]
            ],
            "paint": {
                "line-color": "#20c020",
                "line-width": 3
            }
        },
        {
            "id": "rakennelmat_ilmarata",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    44500
                ]
            ],
            "paint": {
                "line-color": "#191000",
                "line-width": 1
            }
        },
        {
            "id": "rakennelmat_ilmarata_tolppa",
            "type": "circle",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "==",
                "kohdeluokka",
                44591
            ],
            "paint": {
                "circle-color": "#191000",
                "circle-radius": 3
            }
        },
        {
            "id": "rakennelmat_suurjannitelinja",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "all",
                [
                    "any",
                    [
                        "match",
                        [
                            "get",
                            "tasosijainti"
                        ],
                        [
                            1
                        ],
                        true,
                        false
                    ],
                    [
                        "!",
                        [
                            "has",
                            "tasosijainti"
                        ]
                    ]
                ],
                [
                    "match",
                    [
                        "get",
                        "kohdeluokka"
                    ],
                    [
                        22311,
                        22312,
                        22200
                    ],
                    true,
                    false
                ]
            ],
            "paint": {
                "line-color": "#c51b8a",
                "line-width": 2
            }
        },
        {
            "id": "rakennelmat_suurjannite_tolppa",
            "type": "circle",
            "source": "taustakartta",
            "source-layer": "rakennelma",
            "filter": [
                "==",
                "kohdeluokka",
                22392
            ],
            "paint": {
                "circle-color": "#dd1c77",
                "circle-radius": 2
            }
        },
        {
            "id": "tienimet",
            "type": "symbol",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "<",
                    "tasosijainti",
                    1
                ]
            ],
            "layout": {
                "text-field": "{nimi_suomi}        {nimi_ruotsi}",
                "text-font": [
                    "Liberation Sans NLSFI"
                ],
                "symbol-placement": "line",
                "text-size": 12
            },
            "paint": {
                "text-color": "#000",
                "text-halo-color": "#fff",
                "text-halo-width": 1.5,
                "text-halo-blur": 1
            }
        },
        {
            "id": "tienumerot",
            "type": "symbol",
            "source": "taustakartta",
            "source-layer": "liikenne",
            "filter": [
                "all",
                [
                    "<",
                    "tieluokka",
                    5
                ],
                [
                    ">",
                    "tieluokka",
                    0
                ]
            ],
            "layout": {
                "text-field": "{tienumero}",
                "text-font": [
                    "Liberation Sans NLSFI"
                ],
                "symbol-placement": "line",
                "text-size": 16
            },
            "paint": {
                "text-color": "#f00",
                "text-halo-color": "#fff",
                "text-halo-width": 2,
                "text-halo-blur": 1
            }
        },
        {
            "id": "nimisto-maasto-vedet",
            "type": "symbol",
            "source": "taustakartta",
            "source-layer": "nimisto",
            "filter": [
                "match",
                [
                    "get",
                    "teema"
                ],
                [
                    "Maasto",
                    "Vedet"
                ],
                true,
                false
            ],
            "layout": {
                "text-field": [
                    "coalesce",
                    [
                        "get",
                        "nimi_fin"
                    ],
                    [
                        "get",
                        "nimi_swe"
                    ],
                    [
                        "get",
                        "nimi_sme"
                    ],
                    [
                        "get",
                        "nimi_sms"
                    ],
                    [
                        "get",
                        "nimi_smn"
                    ]
                ],
                "text-font": [
                    "match",
                    [
                        "get",
                        "teema"
                    ],
                    "Vedet",
                    [
                        "literal",
                        [
                            "Liberation Sans NLSFI Left"
                        ]
                    ],
                    "Maasto",
                    [
                        "literal",
                        [
                            "Liberation Sans NLSFI Right"
                        ]
                    ],
                    [
                        "literal",
                        [
                            "Liberation Sans NLSFI"
                        ]
                    ]
                ],
                "text-size": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    1,
                    [
                        "step",
                        [
                            "get",
                            "prioriteetti"
                        ],
                        20,
                        3,
                        16
                    ],
                    10,
                    [
                        "step",
                        [
                            "get",
                            "prioriteetti"
                        ],
                        20,
                        4,
                        14
                    ],
                    16,
                    [
                        "step",
                        [
                            "get",
                            "prioriteetti"
                        ],
                        22,
                        5,
                        12
                    ]
                ],
                "visibility": "visible"
            },
            "paint": {
                "text-halo-width": 2,
                "text-halo-color": "rgba(255, 255, 255, 1)",
                "text-color": [
                    "match",
                    [
                        "get",
                        "teema"
                    ],
                    "Vedet",
                    "hsl(251, 71%, 50%)",
                    "hsl(0, 0%, 20%)"
                ],
                "text-halo-blur": 1
            }
        },
        {
            "id": "nimisto",
            "type": "symbol",
            "source": "taustakartta",
            "source-layer": "nimisto",
            "filter": [
                "all",
                [
                    "!",
                    [
                        "match",
                        [
                            "get",
                            "teema"
                        ],
                        [
                            "Maasto",
                            "Vedet"
                        ],
                        true,
                        false
                    ]
                ],
                [
                    "!=",
                    [
                        "get",
                        "alaryhma"
                    ],
                    "Hallintoalueet"
                ],
                [
                    "match",
                    [
                        "get",
                        "laji"
                    ],
                    [
                        "Kansallispuisto",
                        "Luonnonpuisto"
                    ],
                    false,
                    true
                ]
            ],
            "layout": {
                "text-transform": [
                    "match",
                    [
                        "get",
                        "alaryhma"
                    ],
                    "Rautatieliikennepaikat",
                    "uppercase",
                    "none"
                ],
                "text-field": [
                    "coalesce",
                    [
                        "get",
                        "nimi_fin"
                    ],
                    [
                        "get",
                        "nimi_swe"
                    ],
                    [
                        "get",
                        "nimi_sme"
                    ],
                    [
                        "get",
                        "nimi_sms"
                    ],
                    [
                        "get",
                        "nimi_smn"
                    ]
                ],
                "icon-ignore-placement": true,
                "icon-allow-overlap": true,
                "text-font": [
                    "Liberation Sans NLSFI"
                ],
                "text-size": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    1,
                    [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "get",
                            "prioriteetti"
                        ],
                        1,
                        20,
                        3,
                        16
                    ],
                    10,
                    [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "get",
                            "prioriteetti"
                        ],
                        5,
                        16,
                        7,
                        13
                    ],
                    14,
                    [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "get",
                            "prioriteetti"
                        ],
                        5,
                        22,
                        10,
                        12
                    ]
                ],
                "visibility": "visible"
            },
            "paint": {
                "text-halo-width": 2,
                "text-halo-color": "rgba(255, 255, 255, 1)",
                "text-color": [
                    "match",
                    [
                        "get",
                        "teema"
                    ],
                    "Vedet",
                    "hsl(251, 71%, 50%)",
                    "Suojellut kohteet",
                    "hsl(117, 79%, 31%)",
                    "hsl(0, 0%, 15%)"
                ],
                "text-halo-blur": 1
            }
        },
        {
            "id": "nimisto_luonnopuistot",
            "type": "symbol",
            "source": "taustakartta",
            "source-layer": "nimisto",
            "filter": [
                "match",
                [
                    "get",
                    "laji"
                ],
                [
                    "Kansallispuisto",
                    "Luonnonpuisto"
                ],
                true,
                false
            ],
            "layout": {
                "text-field": [
                    "coalesce",
                    [
                        "get",
                        "nimi_fin"
                    ],
                    [
                        "get",
                        "nimi_swe"
                    ],
                    [
                        "get",
                        "nimi_sme"
                    ],
                    [
                        "get",
                        "nimi_sms"
                    ],
                    [
                        "get",
                        "nimi_smn"
                    ]
                ],
                "icon-ignore-placement": true,
                "icon-allow-overlap": false,
                "text-font": [
                    "Liberation Sans NLSFI"
                ],
                "visibility": "visible"
            },
            "paint": {
                "text-halo-width": 2,
                "text-halo-color": "rgba(255, 255, 255, 1)",
                "text-color": "hsl(117, 79%, 31%)",
                "text-halo-blur": 1
            }
        },
        {
            "id": "nimisto_kunnat",
            "type": "symbol",
            "source": "taustakartta",
            "source-layer": "nimisto",
            "filter": [
                "all",
                [
                    "==",
                    [
                        "get",
                        "alaryhma"
                    ],
                    "Hallintoalueet"
                ],
                [
                    "==",
                    [
                        "get",
                        "laji"
                    ],
                    "Kunta"
                ]
            ],
            "layout": {
                "text-field": [
                    "coalesce",
                    [
                        "get",
                        "nimi_fin"
                    ],
                    [
                        "get",
                        "nimi_swe"
                    ],
                    [
                        "get",
                        "nimi_sme"
                    ],
                    [
                        "get",
                        "nimi_sms"
                    ],
                    [
                        "get",
                        "nimi_smn"
                    ]
                ],
                "icon-ignore-placement": false,
                "icon-allow-overlap": false,
                "text-size": [
                    "interpolate",
                    [
                        "exponential",
                        1.35
                    ],
                    [
                        "zoom"
                    ],
                    1,
                    16,
                    14,
                    28
                ],
                "text-font": [
                    "step",
                    [
                        "zoom"
                    ],
                    [
                        "literal",
                        [
                            "Liberation Sans NLSFI"
                        ]
                    ],
                    6,
                    [
                        "literal",
                        [
                            "Liberation Sans NLSFI Bold"
                        ]
                    ]
                ]
            },
            "paint": {
                "text-halo-width": 2,
                "text-halo-color": "rgb(255, 255, 255)",
                "text-color": "hsl(0, 0%, 25%)",
                "text-halo-blur": 1
            }
        },
        {
            "id": "maasto_viiva_portti_este",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "maasto_viiva",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    30300
                ],
                [
                    "==",
                    "kohdeluokka",
                    30400
                ]
            ],
            "paint": {
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.75,
                    20,
                    30
                ],
                "line-color": "blue"
            }
        },
        {
            "id": "maasto_viiva_jyrkanne",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "maasto_viiva",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    34400
                ],
                [
                    "==",
                    "kohdeluokka",
                    34500
                ]
            ],
            "paint": {
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.75,
                    20,
                    30
                ],
                "line-color": "black"
            }
        },
        {
            "id": "maasto_viiva_jyrkanne_pykala",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "maasto_viiva",
            "filter": [
                "any",
                [
                    "==",
                    "kohdeluokka",
                    34400
                ]
            ],
            "minzoom": 14,
            "paint": {
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.75,
                    20,
                    30
                ],
                "line-color": "black",
                "line-offset": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.75,
                    20,
                    30
                ],
                "line-dasharray": [
                    0.1,
                    1
                ]
            }
        },
        {
            "id": "maasto_piste",
            "type": "circle",
            "source": "taustakartta",
            "source-layer": "maasto_piste",
            "filter": [
                "in",
                "kohdeluokka",
                34600,
                72310,
                38511,
                38512,
                39513
            ],
            "paint": {
                "circle-radius": [
                    "interpolate",
                    [
                        "exponential",
                        1.55
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    0.75,
                    20,
                    30
                ],
                "circle-color": "black"
            }
        },
        {
            "id": "suojelualueet",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "alueraja",
            "filter": [
                "in",
                "kohdeluokka",
                72100,
                72200,
                72201,
                72202,
                72400,
                72500,
                72600,
                72800
            ],
            "maxzoom": 14,
            "paint": {
                "line-width": 1,
                "line-color": "rgba(0,192,0,1)"
            }
        },
        {
            "id": "suojelualueet_reuna",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "alueraja",
            "filter": [
                "in",
                "kohdeluokka",
                72100,
                72200,
                72201,
                72202,
                72400,
                72500,
                72600,
                72800
            ],
            "minzoom": 10,
            "maxzoom": 15,
            "paint": {
                "line-width": 3,
                "line-dasharray": [
                    1,
                    2
                ],
                "line-color": "rgba(0,192,0,1)"
            }
        },
        {
            "id": "suoja_alueet",
            "type": "line",
            "source": "taustakartta",
            "source-layer": "alueraja",
            "filter": [
                "in",
                "kohdeluokka",
                62100,
                62200
            ],
            "maxzoom": 14,
            "paint": {
                "line-width": 2,
                "line-color": "red",
                "line-dasharray": [
                    8.5,
                    1.5,
                    1.5,
                    1.5
                ]
            }
        },
        {
            "id": "poi",
            "type": "circle",
            "source": "taustakartta",
            "source-layer": "poi",
            "paint": {
                "circle-color": "red",
                "circle-radius": 3
            }
        },
        {
            "id": "poi_label",
            "type": "symbol",
            "source": "taustakartta",
            "source-layer": "poi",
            "layout": {
                "text-font": [
                    "Liberation Sans NLSFI"
                ],
                "text-field": [
                    "case",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        16126
                    ],
                    "majakka",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        45300
                    ],
                    "savupiippu",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        45800
                    ],
                    "vesitorni",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        45000
                    ],
                    "näkötorni",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        45710
                    ],
                    "tulentekopaikka",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        44800
                    ],
                    "masto",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        45500
                    ],
                    "tuulivoimala",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        34900
                    ],
                    "luontokohde",
                    ""
                ],
                "text-size": 12,
                "text-offset": [
                    0,
                    -1
                ],
                "visibility": "visible"
            },
            "paint": {
                "text-halo-width": 2,
                "text-halo-color": "rgba(255, 255, 255, 1)",
                "text-color": "hsl(0, 0%, 20%)",
                "text-halo-blur": 1
            }
        },
        {
            "id": "maasto_poi",
            "type": "circle",
            "source": "taustakartta",
            "source-layer": "maasto_piste",
            "filter": [
                "match",
                [
                    "get",
                    "kohdeluokka"
                ],
                [
                    34600,
                    35100,
                    72310,
                    72320,
                    72340
                ],
                true,
                false
            ],
            "paint": {
                "circle-color": "#8d7469",
                "circle-radius": 3
            }
        },
        {
            "id": "symbol_label",
            "type": "symbol",
            "source": "taustakartta",
            "source-layer": "symboli",
            "layout": {
                "text-font": [
                    "Liberation Sans NLSFI"
                ],
                "text-field": [
                    "case",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        12200
                    ],
                    "(este)",
                    ""
                ],
                "text-size": 12,
                "text-offset": [
                    0,
                    0.5
                ],
                "visibility": "visible"
            },
            "paint": {
                "text-halo-width": 2,
                "text-halo-color": "rgba(255, 255, 255, 1)",
                "text-color": "hsl(0, 0%, 20%)",
                "text-halo-blur": 1
            }
        },
        {
            "id": "maasto_poi_label",
            "type": "symbol",
            "source": "taustakartta",
            "source-layer": "maasto_piste",
            "layout": {
                "text-font": [
                    "Liberation Sans NLSFI"
                ],
                "text-field": [
                    "case",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        35100
                    ],
                    "puu",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        72310
                    ],
                    "rauhoitettu kivi",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        72320
                    ],
                    "rauhoitettu puu",
                    [
                        "==",
                        [
                            "get",
                            "kohdeluokka"
                        ],
                        72340
                    ],
                    "muu rauhoitettu kohde",
                    ""
                ],
                "text-size": 12,
                "text-offset": [
                    0,
                    -1
                ],
                "visibility": "visible"
            },
            "paint": {
                "text-halo-width": 2,
                "text-halo-color": "rgba(255, 255, 255, 1)",
                "text-color": "hsl(0, 0%, 20%)",
                "text-halo-blur": 1
            }
        },
        {
            "id": "point",
            "source": "point",
            "type": "circle",
            "paint": {
                "circle-radius": 20,
                "circle-color": "white",
                "circle-stroke-color": "#000080",
                "circle-stroke-width": 2,
                "circle-opacity": 0.5
            },
            "filter": [
                "==",
                "$type",
                "Point"
            ]
        }
    ],
    "id": "NLS-Basemap"
}